import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

// These libraries are having some platform type issues that are bubbling up.
// These imports are expected, working to resolve these separately.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitMessages, EmitTransport } from '@mode/reports/sandbox/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitTransportToken } from '@mode/reports/sandbox/util-transport';
import { ErrorEvent, ErrorReporter } from '@mode/shared/contract-common';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';

declare global {
  interface Window {
    modeReportAlamodeError(error: Error, debugInfo?: any): void;
  }
}

/**
 * Implements ErrorReporter to send reports to the outer window via RPC.
 *
 * This is not providedIn: 'root' because we don't want to depend on it directly. Only use ErrorReporter to access this.
 */
@Injectable()
export class ReportSandboxErrorService implements ErrorReporter {
  notify(event: ErrorEvent): void {
    this.emitter.emit(this.$window.parent, new EmitMessages.Error(event));
  }

  constructor(
    private $window: Window,
    @Inject(EmitTransportToken) private emitter: EmitTransport,
    featureFlags: FeatureFlagsFacade,
    @Inject(DOCUMENT) document: Document
  ) {
    featureFlags.asObservable(FeatureFlag.AlamodeErrorReporting).subscribe((enabled) => {
      if (enabled) {
        window.modeReportAlamodeError = (error: Error, debugInfo?: any) => {
          this.notify({ error, context: 'Alamode', debugInfo });
        };
      } else {
        window.modeReportAlamodeError = (error: Error, debugInfo?: any) => {};
      }
    });
  }
}
